'use strict';

const inputPatternUtils = require('../modules/utils/input_pattern_utils');
const trackingUtils = require('../modules/utils/tracking.utils');
const fieldUtils = require('../modules/utils/field.utils');
const creditCardUtils = require('../modules/utils/credit_card.utils');
const creditCardTypes = require('../modules/data/credit_card_types');

var getAvailableCcList = function(ccList, freeFeeKey) {
    return Odigeo._.map(Odigeo._.merge({}, ccList), function(cc) {
        cc.fee = parseFloat(cc.fee);
        var ccFormat = ((cc.fee > 0 ? '+' : '') + Odigeo.Utils.formatCurrency(cc.fee));
        cc.feeDecimal = ccFormat;
        cc.fee = cc.fee === 0 ? freeFeeKey : ccFormat;
        return cc;
    });
};
var PricePublisherMixin = require('../modules/mixins/price_publisher.mixin');

Odigeo.defineWidget('bin_detection_manager', Odigeo.Widget.extend(PricePublisherMixin.extend({
    xhr: null,

    modelClass: Odigeo.Model.extend({
        connect: true,
        selectors: ['bookingId'],
        requestData: null,
        dataURL: '',
        action: '',
        defaults: {
            creditCardResolved: false,
            isPaste: false,
        },
        init: function() {
            Odigeo._.extend(this.widget.options, {hiddenCards: ['VB', 'E1', 'EA']});
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.set('creditCardsDefaultMethod', {code: '', name: ''});
            this.set('creditCardBinDetailsCache', []);
            this.on('change:creditCardBin', this.onCreditCardBinNumberChanged);
            this.on('change:creditCardsSelected', this.creditCardTypeChanged);
        },

        creditCardTypeChanged: function() {
            var cc = this.get('creditCardsSelected');

            var pbItem = {
                concept: cc.code,
                allPrice: cc.fee,
                onePrice: cc.fee,
                quantity: this.widget.options.numtravellers,
                type: 'CC_FEE',
                method: cc.method,
                creditCardResolved: this.get('creditCardResolved'),
            };
            this.widget.addItemToPricemanagerCollection(pbItem);
            Odigeo.trigger(this.widget.id + ':creditCardTypeChanged', cc.code, cc.name, this.get('creditCardResolved'), this.get('showCCDropdown'));
        },

        onCreditCardBinNumberChanged: function() {
            var creditCardBinDetailsCache = this.get('creditCardBinDetailsCache');
            var ccBin = this.get('creditCardBin');
            var binDetailsCached = Odigeo._.find(creditCardBinDetailsCache, {creditCardBin: ccBin});

            if (this.xhr) {
                this.xhr.abort();
            }

            if (Odigeo._.isObject(binDetailsCached)) {
                this.set('creditCardBinDetails', binDetailsCached);
            } else if (ccBin) {
                this.isEmptyData = false;
                this.dataURL = 'getcreditcardbindetailsCardBin';
                this.xhr = this.fetch(this.getRequest({creditCardBin: ccBin}));
            }
        },

        getRequest: function(data) {
            return {
                type: 'POST',
                data: JSON.stringify(data),
                timeout: 11000,
                contentType: 'application/json',
                dataType: 'json',
                cache: false,
                success: Odigeo._.bind(this.requestSuccessHandler, this),
                error: Odigeo._.bind(this.requestErrorHandler, this),
            };
        },

        requestSuccessHandler: function(model, data) {
            if (data.error) {
                this.widget.view._creditCardNotDetected(data.error);
            } else {
                var creditCardBinDetailsCache = this.get('creditCardBinDetailsCache');
                creditCardBinDetailsCache.push(data);
                model.set({
                    creditCardBinDetails: data,
                    creditCardBinDetailsCache: creditCardBinDetailsCache,
                });
            }
            this.xhr = null;
        },

        requestErrorHandler: function() {
            this.xhr = null;
            this.widget.view._creditCardNotDetected('ERROR500_ONEFRONT_NOT_RESPONSE');
        },

        url: function() {
            return Odigeo.Settings.getProperty('serviceCollectionMethodFormatter')(this.dataURL);
        },
    }),
    viewClass: Odigeo.View.extend({
        templateSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
        },
        selectors: {
            binDetectionContainer: '.bin_detection_container',
            ccFeePrice: '.cc_fee_price',
            ccnumber: 'input[name="ccnumber"]',
            binDetectionCcFeesListTemplate: '.bin_detection_cc_fees_list_template',
            creditCardFeesBinDetection: '#creditCardFeesBinDetection',
            binDetectionCcFeesList: '.bin_detection_cc_fees_list',
            ccCardType: 'select.cardTypeSelector',
            ccTypeIcon: '.cc_type_icon',
            ccNotDetected: '.cc_not_detected',
            ccDetectedSelectedOk: '.cc_detected_selected_ok',
            ccNumberNotAvailable: '.cc_number_not_available',
            openCcList: '.open_cc_list',
            ccFeesInfo: '.cc_fees_info',
            cardLogos: '.card_logos ul',
            clearInput: '.clear_input',
            binDetectionNoCcFeesInfo: '.bin_detection_no_cc_fees_info',
            ccFeePriceContainer: '.cc_fee_price_container',
        },

        init: function() {
            this.listenTo(this.model, 'change:creditCardBinDetails', this.onCreditCardBinDetailsChanged);
            this.listenTo(this.model, 'change:creditCardsList', this.onCreditCardsFeesChanged);
            this.listenTo(this.model, 'change:showCCDropdown', this.onShowCCDropdown);
            this.$cachedSelectors.clearInput.on(Odigeo.Events.tap, Odigeo._.bind(this.widget.creditCardNumberChanged, this.widget, false));
            this.$cachedSelectors.cardLogos.on(Odigeo.Events.tap, Odigeo._.bind(this.onTapOnCardLogos, this));
            this.$cachedSelectors.ccnumber.on(Odigeo.Events.change, Odigeo._.bind(this.widget.creditCardNumberChanged, this.widget, false));
            this.$cachedSelectors.ccCardType.on(Odigeo.Events.change, Odigeo._.bind(this.creditCardSelectorTypeChanged, this));
        },

        onShowCCDropdown: function() {
            const showCCDropdown = this.model.get('showCCDropdown');
            Odigeo.trigger(`${this.widget.id}:showCCDropdown`, showCCDropdown);
            this.$cachedSelectors.ccNotDetected.toggleClass('odf-hidden', !showCCDropdown);
        },

        onTapOnCardLogos: function() {
            this._trackEvent('credict_card_logo_click');
        },

        setCreditCardFormat: function(defaultCode) {
            var creditCardDetails = this.model.get('creditCardsSelected');
            var ccCode = defaultCode || creditCardDetails.code;
            if (ccCode) {
                inputPatternUtils.setSelectedCreditCard(ccCode);
                this.$cachedSelectors.ccnumber.trigger(Odigeo.Events.input).trigger(Odigeo.Events.keydown);
            }
        },

        creditCardSelectorTypeChanged: function() {
            var selectedCcType = this.$cachedSelectors.ccCardType.val();
            var isSelected = selectedCcType !== '';
            var cc = isSelected && selectedCcType ? this._getCcFromAvailableList(selectedCcType) : this.model.get('creditCardsDefaultMethod');
            if (isSelected) {
                this._updateSelectedCcIconAndFee(cc);
                this.$cachedSelectors.ccNotDetected.find('.paymentmanager_row').removeAttr('data-state');
            } else {
                this._cleanFeeAndFlag();
                this.$cachedSelectors.ccCardType.closest('.paymentmanager_row').attr('data-state', 'init');
            }
            this.model.set({creditCardResolved: isSelected, creditCardsSelected: cc});
            this.setCreditCardFormat();
            Odigeo.trigger(this.widget.id + ':showPaymentMethodDisclaimer', {
                ccName: cc.name,
                resolved: this.model.get('creditCardResolved'),
            });
            this.$cachedSelectors.ccDetectedSelectedOk.toggleClass('odf-hidden', !isSelected);
            this.$cachedSelectors.ccCardType.toggleClass('ccNotSelected', !isSelected);
        },

        _getCcFromAvailableList: function(ccCode) {
            var cc = Odigeo._.filter(this.model.get('creditCardsList'), {code: ccCode});
            return !Odigeo._.isEmpty(cc) ? cc.shift() : null;
        },

        _updateSelectedCcIconAndFee: function(cc) {
            var fee = parseFloat(cc.fee);
            var content;
            this.$cachedSelectors.ccTypeIcon.attr('data-card', cc.code);
            this.$cachedSelectors.cardLogos.addClass('odf-hidden');
            content = fee === 0 ?
                this.widget.options.freeFee :
                (fee > 0 ? '+' : '') + Odigeo.Utils.formatCurrency(fee);
            this.$cachedSelectors.ccFeePrice.html(content).removeClass('odf-hidden');
        },

        _clearBinElements: function() {
            this.$cachedSelectors.ccDetectedSelectedOk.removeClass('odf-hidden');
            this.model.set('showCCDropdown', false);
            this._cleanFeeAndFlag();
        },

        _cleanFeeAndFlag: function() {
            this.$cachedSelectors.ccTypeIcon.attr('data-card', '');
            this.$cachedSelectors.cardLogos.removeClass('odf-hidden');
            this.$cachedSelectors.ccFeePrice.html('').addClass('odf-hidden');
        },

        _fillSelectedCard: function(ccCode) {
            var cc = this._getCcFromAvailableList(ccCode);
            var isCreditCardResolved = false;

            if (cc !== null && this.$cachedSelectors.ccTypeIcon.attr('data-card') !== cc.code) {
                this._clearBinElements();
                this._updateSelectedCcIconAndFee(cc);
                isCreditCardResolved = true;
            } else if (cc === null) {
                cc = this.model.get('creditCardsDefaultMethod');
                this._creditCardNotDetected('NOT_ACCEPTED');
            }
            this.model.set({creditCardsSelected: cc, creditCardResolved: isCreditCardResolved});

            Odigeo.trigger(this.widget.id + ':showPaymentMethodDisclaimer', {
                ccName: cc.name,
                resolved: isCreditCardResolved,
            });
        },

        _getCcCode: function(creditCardBinDetails) {
            const creditCardList = this.model.get('creditCardsList');
            let ccCode;
            const code = !!creditCardBinDetails && creditCardBinDetails.creditCardTypeDTO.creditCardCode;
            if (Odigeo._.find(creditCardList, {code: code})) {
                ccCode = code;
            }
            return ccCode;
        },

        onCreditCardBinDetailsChanged: function() {
            var creditCardBinDetails = this.model.get('creditCardBinDetails');
            var ccCode = this._getCcCode(creditCardBinDetails);
            // Bin Service do not detect the CC //
            var error = !!creditCardBinDetails && creditCardBinDetails.creditCardTypeDTO.creditCardCode ? error : 'NOT_DETECTED';

            // Bin Service detects the CC but it's no one of the valid CC allows by DAPI //
            error = Odigeo._.isUndefined(error) && !ccCode ? 'NOT_ACCEPTED' : error;
            if (Odigeo._.isUndefined(error)) {
                this._fillSelectedCard(ccCode);
                this.setCreditCardFormat();
            } else if (!this.model.get('showCCDropdown')) {
                this._creditCardNotDetected(error);
                this.setCreditCardFormat('default');
            }
            if (creditCardBinDetails) {
                Odigeo.trigger(this.widget.id + ':showPsd2InfoMsg', creditCardBinDetails.europeanCard);
            }
        },

        _creditCardNotDetected: function(type) {
            var cc = this.model.get('creditCardsSelected');
            var nonDetectedType = {
                ERROR500: 'bin_card_type_KO_error500',
                TIMEOUT: 'bin_card_type_KO_timeout',
                NOT_DETECTED: 'bin_card_type_KO_number_' + this.model.get('creditCardBin'),
                NOT_ACCEPTED: 'bin_card_type_KO_acceptance',
                ERROR500_ONEFRONT_NOT_RESPONSE: 'bin_card_type_KO_no_response',
            };
            this._clearBinElements();
            this.$cachedSelectors.ccCardType.addClass('ccNotSelected');
            this.model.set({showCCDropdown: true, creditCardsSelected: cc, creditCardResolved: false});
            Odigeo.trigger(this.widget.id + ':showPaymentMethodDisclaimer', {
                ccName: cc.name,
                resolved: false,
            });
            this._trackEvent(nonDetectedType[type]);
        },
        shallShowCcList: function() {
            var hiddenCards = this.widget.options.hiddenCards;
            return Odigeo._.filter(this.model.get('creditCardsList'), Odigeo._.bind(function(item) {
                return !Odigeo._.includes(hiddenCards, item.code);
            }, this)).length <= hiddenCards.length;
        },

        _trackEvent: function(label) {
            // Analytics: event tracking
            trackingUtils.trackEvent('bin_upgrade_detection', label, Odigeo.History.getPageNameFromFragment());
        },

        _setCcFeesHint: function(ccListWithCurrency) {
            var ccFeesTemplate = Odigeo._.template(this.$cachedSelectors.binDetectionCcFeesListTemplate.html(), this.templateSettings);
            var tapEvent = this.widget.options.showCCFeesDetails;
            var ccListHint;
            var feesZero = true;

            this.$cachedSelectors.creditCardFeesBinDetection.html(ccFeesTemplate({ccList: ccListWithCurrency}));
            ccListHint = Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.binDetectionCcFeesList, {
                events: {
                    tap: tapEvent,
                },
                trigger: this.widget.id + ':ccFeesHint',
            });
            this.$cachedSelectors.binDetectionCcFeesList.removeClass('odf-hidden');
            this.$cachedSelectors.openCcList.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                ccListHint.trigger('showHint');
            });

            this.$cachedSelectors.ccFeesInfo.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                ccListHint.trigger('showHint');
            });

            feesZero = !Odigeo._.some(ccListWithCurrency, function(cc) {
                return cc.feeDecimal !== Odigeo.Utils.formatCurrency(0);
            });

            if (feesZero) {
                this.$cachedSelectors.ccFeesInfo.addClass('odf-hidden');
                this.$cachedSelectors.ccFeePriceContainer.addClass('odf-hidden');
                this.$cachedSelectors.binDetectionCcFeesList.addClass('odf-hidden');
            }
        },

        updateCCBinIcon: function(ccCode) {
            const cc = this._getCcFromAvailableList(ccCode);

            if (cc !== null && this.$cachedSelectors.ccTypeIcon.attr('data-card') !== cc.code) {
                this._updateSelectedCcIconAndFee(cc);
            }
        },

        addCreditCardOption: function(cc, $select) {
            const shallShowHiddenCards = this.shallShowCcList();
            if (!this.widget.options.hiddenCards.includes(cc.code) || shallShowHiddenCards) {
                $select.append(
                    $('<option/>')
                        .val(cc.code)
                        .attr('class', 'ccType')
                        .html(cc.name || Odigeo._.get(creditCardTypes[cc.code], 'name', cc.code))
                );
            }
        },

        onCreditCardsFeesChanged: function() {
            const ccList = getAvailableCcList(this.model.get('creditCardsList'), this.widget.options.freeFee);
            const $select = $('<select/>');
            this._setCcFeesHint(ccList);

            // Non CC type detected
            this.$cachedSelectors.ccCardType.find('option[value!=""]').remove();
            ccList.forEach((cc) => this.addCreditCardOption(cc, $select));
            this.$cachedSelectors.ccCardType.append($select.find('option'));
            this.$cachedSelectors.ccCardType.val('');
        },
    }),

    creditCardNumberChanged: Odigeo._.debounce(function(isPaste) {
        var newCcNumber = this.view.$cachedSelectors.ccnumber.val();
        var binCcNumber;
        var ccDefault = this.model.get('creditCardsDefaultMethod');
        this.model.set('isPaste', isPaste);
        newCcNumber = fieldUtils.trimCreditCardNumber(newCcNumber);
        if (creditCardUtils.isValidPCICreditCardBin(newCcNumber)) {
            Odigeo.trigger(`${this.id}:checkRiskyCard`, creditCardUtils.getPCIBinCCNumber(newCcNumber));
        }
        if (creditCardUtils.isValidPCICreditCardBin(newCcNumber)) {
            binCcNumber = creditCardUtils.getPCIBinCCNumber(newCcNumber);
            if (binCcNumber !== this.model.get('creditCardBin')) {
                this.model.set('creditCardBin', binCcNumber);
            }
        } else if (this.view.$cachedSelectors.ccTypeIcon.attr('data-card') !== '' || this.model.get('showCCDropdown')) {
            this.model.set({creditCardsSelected: ccDefault, creditCardResolved: false});
            Odigeo.trigger(this.id + ':showPaymentMethodDisclaimer', {
                ccName: ccDefault.name,
                resolved: false,
            });
            this.view._clearBinElements();
        }
    }, 300),


    setCCFees: function(ccList) {
        this.model.set('creditCardsList', ccList.cards);
        if (Odigeo._.isObject(ccList.defaultCc)) {
            this.model.set('creditCardsDefaultMethod', ccList.defaultCc);
            if (ccList.chosenMethod === 'CREDITCARD') {
                this.model.set('creditCardsSelected', ccList.defaultCc);
            }
        }
        if (this.view.$cachedSelectors.ccnumber.val()) {
            this.creditCardNumberChanged(false);
        }
    },

    triggerInputEventOnCreditCardInput: function() {
        this.view.$cachedSelectors.ccnumber.trigger(Odigeo.Events.input);
    },

    resetBinDetectionModel() {
        this.model.set({
            creditCardBin: 1,
            creditCardBinDetailsCache: [],
            creditCardBinDetails: {},
        }, {silent: true});
    },

    getCcSelectedName: function() {
        var cc = this.model.get('creditCardsSelected');
        cc = !cc ? this.model.get('creditCardsDefaultMethod') : cc;
        if (cc.code !== '') {
            Odigeo.trigger(this.id + ':methodTypeChanged', cc.name);
            this.model.set('creditCardsSelected', cc);
        }
    },

    isValid: function() {
        return !this.model.get('showCCDropdown') || !!this.view.$cachedSelectors.ccCardType.val();
    },
})));
